import { render, staticRenderFns } from "./crunchie2.vue?vue&type=template&id=a0c226b2&scoped=true&"
import script from "./crunchie2.vue?vue&type=script&lang=js&"
export * from "./crunchie2.vue?vue&type=script&lang=js&"
import style0 from "./crunchie2.vue?vue&type=style&index=0&id=a0c226b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c226b2",
  null
  
)

export default component.exports